import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { notifyParentOfUrlChange } from "../utils/iframe_messaging"

export default class extends Controller {
  static values = {
    nextUrl: String,
    prevUrl: String
  }

  connect() {
    this.startX = 0;
    this.endX = 0;
    this.element.addEventListener("touchstart", this.handleTouchStart.bind(this), { passive: true });
    this.element.addEventListener("touchend", this.handleTouchEnd.bind(this), { passive: true });
  }

  handleTouchStart(e) {
    this.startX = e.changedTouches[0].screenX;
  }

  handleTouchEnd(e) {
    this.endX = e.changedTouches[0].screenX;
    const deltaX = this.endX - this.startX;

    if (Math.abs(deltaX) > 50) {
      if (deltaX < 0 && this.nextUrlValue) {
        this.animateAndVisit("left", this.nextUrlValue);
      } else if (deltaX > 0 && this.prevUrlValue) {
        this.animateAndVisit("right", this.prevUrlValue);
      }
    }
  }

  animateAndVisit(direction, url) {
    const frame = this.element.querySelector("turbo-frame") || this.element;

    // Add animation class
    frame.classList.add("transition-transform", "duration-300", direction === "left" ? "-translate-x-full" : "translate-x-full");

    // Wait for animation to complete before navigating
    setTimeout(() => {
      notifyParentOfUrlChange(url);
      Turbo.visit(url, { action: "replace" });
    }, 300);
  }
}
